export const analytics_store = {
  data: { workspaceOwnerEmail: null },
  set: payload => {
    for (const index in payload) {
      analytics_store.data[index] = payload[index];
    }
  },
  get: () => analytics_store?.data,
};

// All third-party analytics sinks (Amplitude, HubSpot) have been removed.
// AppAnalytics is kept as a no-op shell so existing call sites keep working.
export const AppAnalytics = {
  identify: () => {},
  track: () => {},
  page: () => {},
  reset: () => {},
};

export const analyticsCoachmarksDone = () => {
  AppAnalytics.track("coachmark.done.clicked", {
    page: window.location.pathname,
  });
};
